import { render, staticRenderFns } from "./EditPictureDialog.vue?vue&type=template&id=fa7224b0"
import script from "./EditPictureDialog.vue?vue&type=script&lang=js"
export * from "./EditPictureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports